// Tag: small inline label. Used in skill grids, project tags, etc.
// Distinct from Chip — Tag is monochrome, plain. Chip is brand-coloured (mint/magenta).

import type { ReactNode } from 'react';
import { cx } from '@lib/utils/classNames';

export interface TagProps {
  children: ReactNode;
  className?: string;
}

export function Tag({ children, className }: TagProps) {
  return <span className={cx('tag', className)}>{children}</span>;
}
